export const handleOverviewInfoDrop = (e, data, {
    setOverviewInfoPosi,
    tempTabIndexOverviewInfo,
    tempImages,
    setTempImages,
    setUpdatedImages,
    id,
    x,
    y
}) => {
    const newPosition = { x: data.x, y: data.y };
    setOverviewInfoPosi(newPosition);
    if (Object.keys(tempTabIndexOverviewInfo).length > 0) {

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );

        const updatedTempImages = [...tempImages];

        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            x: x !== null ? x + data.x : 70,
            y: y !== null ? y + data.y : 20,
        };

        updatedTempImages[originalDeviceIndex] = updatedData;

        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};

// Function to handle the position of a graph component in a overview tab 
export const handleOverviewGraphDrop = (e, data, {
    setOverviewGraphPosi,
    tempTabIndexOverviewGraph,
    tempImages,
    setTempImages,
    setUpdatedImages,
    id,
    x,
    y,
}) => {

    const newPosition = { x: data.x, y: data.y };
    setOverviewGraphPosi(newPosition);
    if (Object.keys(tempTabIndexOverviewGraph).length > 0) {

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedTempImages = [...tempImages];
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            x: x !== null ? x + data.x : 570,
            y: y !== null ? y + data.y : 70,
        };

        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};

// Function to handle the width/height of a graph component in a overview tab 
export const handleOverviewGraphDimension = (e, {
    tempImages,
    setOverviewGraphDimension,
    tabIndexOverviewGraph,
    setTempImages,
    setUpdatedImages,
    id
}) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById("overviewGraph");
    const newDimension = {
        width: dimension.style.width,
        height: dimension.style.height,
    };


    setOverviewGraphDimension(newDimension);
    if (Object.keys(tabIndexOverviewGraph).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            width: newDimension.width,
            height: newDimension.height,
        };
        updatedTempImages[originalDeviceIndex] = updatedData;

        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};

// Function to handle the position of a graph component in a livedata tab 

export const handleLiveDataGraphDrop = (e, data, {
    setLiveDataGraphPosi,
    tempTabIndexLiveDataGraph,
    tempImages,
    setTempImages,
    setUpdatedImages
    , id,
    x,
    y
}) => {
    const newPosition = { x: data.x, y: data.y };

    setLiveDataGraphPosi(newPosition);
    if (Object.keys(tempTabIndexLiveDataGraph).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedTempImages = [...tempImages];
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            x: x !== null ? x + data.x : 277,
            y: y !== null ? y + data.y : 60,
        };
        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);

    }
};

// Function to handle the width/height of a graph component in a livedata tab 

export const handleLiveDataDimension = (e, {
    tempImages,
    setLiveDataGraphDimension,
    tabIndexLiveDataGraph,
    setTempImages,
    setUpdatedImages,
    id
}) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById("liveDataGraph");
    const newDimension = {
        width: dimension.style.width,
        height: dimension.style.height,
    };

    setLiveDataGraphDimension(newDimension);
    if (Object.keys(tabIndexLiveDataGraph).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            width: newDimension.width,
            height: newDimension.height,
        };
        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};


// Function to handle the position of a table component in a 24-hour tab 
export const handleLastDayTableDrop = (e, data, {
    setLastDayTablePosi,
    tempTabIndexLastDayTable,
    tempImages,
    setTempImages,
    setUpdatedImages, id, x, y
}) => {
    const newPosition = { x: data.x, y: data.y };
    setLastDayTablePosi(newPosition);
    if (Object.keys(tempTabIndexLastDayTable).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedTempImages = [...tempImages];
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            x: x !== null ? x + data.x : 200,
            y: y !== null ? y + data.y : 10,
        };
        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};

// Function to handle the width/height of a table component in a 24-hour tab 
export const handleLastDayTableDimension = (e, {
    tempImages,
    setLastDayTableDimension,
    tabIndexLastDayTable,
    setTempImages,
    setUpdatedImages,
    id
}) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById("lastDayTable");
    const newDimension = {
        width: dimension.style.width,
        height: dimension.style.height,
    };

    setLastDayTableDimension(newDimension);
    if (Object.keys(tabIndexLastDayTable).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            width: newDimension.width,
            height: newDimension.height,
        };
        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};

// Function to handle the position of a graph component in a 24-hour tab  
export const handleLastDayGraphDrop = (e, data, {
    setLastDayGraphPosi,
    tempTabIndexLastDayGraph,
    tempImages,
    setTempImages,
    setUpdatedImages,
    id,
    x,
    y
}) => {
    const newPosition = { x: data.x, y: data.y };
    setLastDayGraphPosi(newPosition);
    if (Object.keys(tempTabIndexLastDayGraph).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedTempImages = [...tempImages];
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            x: x !== null ? x + data.x : 500,
            y: y !== null ? y + data.y : 80,
        };

        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};

// Function to handle the width/height of a graph component in a 24-hour tab 
export const handleLastDayGraphDimension = (e, {
    tempImages,
    setLastDayGraphDimension,
    tabIndexLastDayGraph,
    setTempImages,
    setUpdatedImages,
    id
}) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById("lastDayGraph");
    const newDimension = {
        width: dimension.style.width,
        height: dimension.style.height,
    };

    setLastDayGraphDimension(newDimension);
    if (Object.keys(tabIndexLastDayGraph).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            width: newDimension.width,
            height: newDimension.height,
        };
        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};

// Function to handle the width/height in a Gridview Tab 
export const handleDefaultGridDimension = (e, {
    tempImages,
    setDefaultGridDimension,
    tabIndexDefaultGrid,
    setTempImages,
    setUpdatedImages,
    id
}) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById("DefaultGrid");
    const newDimension = {
        width: dimension.style.width,
        height: dimension.style.height,
    };

    setDefaultGridDimension(newDimension);
    if (Object.keys(tabIndexDefaultGrid).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            width: newDimension.width,
            height: newDimension.height,
        };
        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};

// Function to handle position of grid view of tab
export const handleDefaultGridDrop = (e, data, {
    setDefaultGridPosi,
    tempTabIndexDefaultGrid,
    tempImages,
    setTempImages,
    setUpdatedImages,
    id,
    x,
    y
}) => {
    const newPosition = { x: data.x, y: data.y };
    setDefaultGridPosi(newPosition);
    if (Object.keys(tempTabIndexDefaultGrid).length > 0) {
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );
        const updatedTempImages = [...tempImages];
        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            x: x + data.x,
            y: y + data.y,
        };
        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);
    }
};